<template>
    <div class="fs5-earnings">
        <fs5-section-header :view="view.header" />
        <div class="fs5-earnings-content" >
            <div class="fs5-earnings-content-buttons">
                <fs5-button
                    v-for="(item, index) in view.buttons"
                    :key="index"
                    :label="item.label"
                    :btn-type="index == buttonActive ? 'primary' : item.btnType"
                    :text-transform-type="item.textTransformType"
                    @clicked="clicked(index)"
                ></fs5-button>
            </div>
            <div class="fs5-earnings-content-cards">
                <fs5-earnings-card
                    v-for="(item, index) in sanitizedCards"
                    :key="index"
                    :view="item"
                />
            </div>

            <div class="fs5-earnings-loader" v-show="loading" >
                <spring-spinner
                    :animation-duration="2000"
                    :size="50"
                    color="#0080fc"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { SpringSpinner } from 'epic-spinners'
    import axios from "axios";
    export default {
        name: 'fs5-earnings',
        props: ['view'],
        components: {
            'spring-spinner': SpringSpinner
        },
        data: function () {
            return {
                buttonActive: 4,
                currentTime: "ALL_TIME",
                loading: false,
                currentStartLevel: 0,
                currentEndLevel: 0,
                hostMicroservice: 'https://bucket.services.builderall.com', // 'https://bucket.services.builderall.com' // develop of api is not working, do a production request
                first: {
                    leads: 0,
                    active_leads: 0,
                    affiliates: 0,
                    usd: 0,
                    eur: 0,
                    brl: 0,
                    btc: 0
                },
                second: {
                    leads: 0,
                    active_leads: 0,
                    affiliates: 0,
                    usd: 0,
                    eur: 0,
                    brl: 0,
                    btc: 0
                },
                third: {
                    leads: 0,
                    active_leads: 0,
                    affiliates: 0,
                    usd: 0,
                    eur: 0,
                    brl: 0,
                    btc: 0
                }
            }
        },
        methods: {
            clicked: async function (index) {
                await this.activeButton(index); // marca botao como ativo e muda o periodo
                await this.handleData();
            },
            activeButton(index) {
                this.buttonActive = index;
                switch(index) {
                    case 0:
                        this.currentTime = 'THIS_MONTH';
                        break;
                    case 1:
                        this.currentTime = 'LAST_MONTH';
                        break;
                    case 2:
                        this.currentTime = 'LAST_3_MONTH';
                        break;
                    case 3:
                        this.currentTime = 'LAST_6_MONTH';
                        break;
                    case 4:
                        this.currentTime = 'ALL_TIME';
                        break;
                    default:
                        break;
                }
            },
            handleData: async function( levelStart = 0, levelEnd = 100 ) {
                this.loading = true;
                let vm = this;

                if(this.currentStartLevel == 0 && this.currentEndLevel == 0) {
                    // inicializacao, geralmente 0 e 100
                    this.currentStartLevel = levelStart;
                    this.currentEndLevel = levelEnd;
                }

                try{
                    const apiUrl = this.urlOfficeApi + this.leadsEarnsHub + `/${this.currentTime}`;

                    const headers = {
                      'Content-Type' : 'application/json',
                      'authorization': `Bearer ${this.userToken}`,
                    };

                    const options = {
                      method: 'GET',
                      headers,
                    };

                    fetch(apiUrl, options)
                      .then(response => {
                        if (!response.ok) {
                          throw new Error('Leads & earns hub error. Network response was unsuccessful');
                        }

                        return response.json();
                      })
                      .then(result => {
                        if(!!result.data && result.data.length) {
                          const resultset = result.data[0];

                          this.$set(this.$data, 'first', { // first card
                            leads: resultset.all_leads,
                            active_leads: resultset.active_leads,
                            affiliates: resultset.sum_is_affiliate,
                            usd: resultset.sum_AllEarnings_USD,
                            eur: resultset.sum_AllEarnings_EUR,
                            brl: resultset.sum_AllEarnings_BRL,
                            btc: 0
                          });

                          this.$set(this.$data, 'second', { // second card
                            leads: resultset.all_direct_leads,
                            active_leads: resultset.all_direct_active_leads,
                            affiliates: resultset.sum_is_direct_affiliate,
                            usd: resultset.sum_DirectSales_USD,
                            eur: resultset.sum_DirectSales_EUR,
                            brl: resultset.sum_DirectSales_BRL,
                            btc: 0
                          });

                          this.$set(this.$data, 'third', {  // third card
                            leads: resultset.all_leads_above_nivel0,
                            active_leads: resultset.all_active_leads_above_nivel0,
                            affiliates: resultset.sum_affiliates_above_nivel0,
                            usd: resultset.sum_sales_above_nivel0_USD,
                            eur: resultset.sum_sales_above_nivel0_EUR,
                            brl: resultset.sum_sales_above_nivel0_BRL,
                            btc: 0
                          });
                        }
                      })
                      .catch(error => {
                        console.error('There was a problem with the search operation:', error);
                      });

                    /* Refactored: Get data from OFFICE API - remove this code block after 2023-11-01
                    const response = await fetch(`${this.hostMicroservice}/users/${this.$parent.view.dados_usuario_office.id}/level?start=${vm.currentStartLevel}&end=${vm.currentEndLevel}&period=${this.currentTime}`);
                    let res = await response.json();
                    console.log('Response: ',res);

                    this.$set(this.$data, 'first', { // primeiro card
                        leads: res.leads,
                        active_leads: res.activeLeads,
                        affiliates: res.isAffiliate,
                        usd: res.earningsUSD,
                        eur: res.earningsEUR,
                        brl: res.earningsBRL,
                        btc: 0
                    });
                    this.$set(this.$data, 'second', { // segundo card
                        leads: res.directLeads,
                        active_leads: res.directActiveLeads,
                        affiliates: res.directIsAffiliate,
                        usd: res.directEarningsUSD,
                        eur: res.directEarningsEUR,
                        brl: res.directEarningsBRL,
                        btc: 0
                    });

                    //para buscar o indiretos
                    try{
                        const response2 = await fetch(`${this.hostMicroservice}/users/${this.$parent.view.dados_usuario_office.id}/level?start=${ ( vm.currentStartLevel + 1) }&end=${ vm.currentEndLevel }&period=${vm.currentTime}`);
                        let res2 = await response2.json();

                        this.$set(this.$data, 'third', {  // terceiro card
                            leads: res2.leads,
                            active_leads: res2.activeLeads,
                            affiliates: res2.isAffiliate,
                            usd: res2.earningsUSD,
                            eur: res2.earningsEUR,
                            brl: res2.earningsBRL,
                            btc: 0
                        });
                    }catch(e){
                        console.log('error: ', e)
                    }finally{}
                    */
                } catch (e) {
                    console.log("error: ", e);
                } finally {
                    vm.loading = false
                }
            }
        },
        created: async function () {
            this.userToken     = this.view.userToken;
            this.urlOfficeApi  = this.view.routes.url_office_api;
            this.leadsEarnsHub = this.view.routes.office_api_affiliate_leads_earns_hub

            await this.handleData();
        },
        computed: {
            sanitizedCards() { // inserindo valor nos cards
                let cards = JSON.parse(JSON.stringify(this.view.cards)); // removendo reatividade

                // card 1
                cards[0].content1[0].value = this.first.leads
                cards[0].content1[1].value = this.first.active_leads
                cards[0].content1[2].value = this.first.affiliates
                cards[0].content2[0].value = `$ ${this.first.usd}`
                cards[0].content2[1].value = `€ ${this.first.eur}`
                cards[0].content2[2].value = `R$ ${this.first.brl}`

                // card 2
                cards[1].content1[0].value = this.second.leads
                cards[1].content1[1].value = this.second.active_leads
                cards[1].content1[2].value = this.second.affiliates
                cards[1].content2[0].value = `$ ${this.second.usd}`
                cards[1].content2[1].value = `€ ${this.second.eur}`
                cards[1].content2[2].value = `R$ ${this.second.brl}`

                // card 3
                cards[2].content1[0].value = this.third.leads
                cards[2].content1[1].value = this.third.active_leads
                cards[2].content1[2].value = this.third.affiliates
                cards[2].content2[0].value = `$ ${this.third.usd}`
                cards[2].content2[1].value = `€ ${this.third.eur}`
                cards[2].content2[2].value = `R$ ${this.third.brl}`

                return cards
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-earnings{
        font: inherit;
        .fs5-earnings-content{
            font: inherit;
            display: grid;
            grid-template-columns: 15.9208262% auto;
            grid-template-rows: auto;
            column-gap: 3.3em;
            position: relative;
            .fs5-earnings-content-buttons{
                font: inherit;
                padding: 2.8em;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: stretch;
                row-gap: 1.2em;

                background-color: $fs5-color2;
                border: 1px $fs5-color1 solid;
                border-radius: 0.8em;
            }
            .fs5-earnings-content-cards{
                font: inherit;
                display: grid;
                grid-template-columns: 1fr 1fr 1fr;
                grid-template-rows: auto;
                justify-content: stretch;
                align-items: stretch;
                column-gap: 1.8em;
            }
            .fs5-earnings-loader{
                font: inherit;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: $fs5-color2;

                background-color: $fs5-color2;
                border-radius: 0.8em;

                display: flex;
                justify-content: center;
                align-items: center;

                opacity: 0.95;

            }
        }
    }

    @media screen and (max-width: 1366px) {
        .fs5-earnings{
            .fs5-earnings-content{
                grid-template-columns: 1fr;
                row-gap: 1em;
            }
        }
    }
    @media screen and (max-width: 980px) {
        .fs5-earnings{
            .fs5-earnings-content{
                .fs5-earnings-content-cards{
                    grid-template-columns: 1fr;
                    row-gap: 1em;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/earnings/index.vue